snt-image {
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  .hidden {
    display: none;
  }

  .hiddenOnMobile {
    display: none;
    @media (min-width: map-get($grid-breakpoints, md)) {
      display: block;
    }
  }

  &[data-width] {
    img {
      width: 100%;
      @media (min-width: map-get($grid-breakpoints, md)) {
        width: var(--blog-img-width, 100%);
      }
    }
  }

  .center {
    margin-left: auto;
    margin-right: auto;
  }

  .left {
    margin-right: auto;
  }

  .right {
    margin-left: auto;
  }
}
